import { h } from 'preact'
import ButtonControl from '../button-control'
import Icon, { IconType } from '../assets'

interface ActionButtonsProps {
    onSave: () => void,
    onCancel: () => void,
}
export const ActionButtons = ({ onSave, onCancel }: ActionButtonsProps) => (
  <div className='panel-buttons-container'>
    <ButtonControl newStyle size='medium' variant='save' title='Save changes' onClick={() => onSave()} />
    <ButtonControl newStyle size='medium' title='Cancel' onClick={() => onCancel()} />
  </div>
)

export const HowToTextWithOpenInNewTabIcon = ({ label, url } : { label: string, url: string }) => (
  <div>
    <a href={url} target='_blank'>
      <span className='how-to-link'> {label}</span>
      <Icon customClass={'icon-open-in-new'} icon={'openInNew'} width={12} height={12} />
    </a>
  </div>
)

export const InformationCallout = ({ text }: { text: string }) => (
  <div className='panel-form-information'>
    <div><Icon icon={'info'} customClass='icon-info' /></div>
    <div className='panel-form-info-text'>{text}</div>
  </div>
)
interface Props {
    title: string,
    statusText?: string,
    iconCustomClass?: string,
    customClass?: string,
    icon?: IconType,
}

export const PanelHeaderWithIcon = ({ title, statusText, iconCustomClass = '', icon, customClass = '' } : Props) => (
  <div className={customClass}>
    { icon && <Icon customClass={iconCustomClass} icon={icon} />}
    <span className='panel-header-title'>{title}</span>
    <span className={`panel-header-status status-${statusText}`}>{statusText}</span>
  </div>
)
